import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=820dca4c&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=820dca4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820dca4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('820dca4c')) {
      api.createRecord('820dca4c', component.options)
    } else {
      api.reload('820dca4c', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=820dca4c&scoped=true&", function () {
      api.rerender('820dca4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Ya7mWATbsaJ9/JS/comp/SearchFilterTokens.vue"
export default component.exports